<script>
  import Login from "./Login.svelte";
  import { getUser, logout } from "../user.js";
  import { showLogin } from "../event.js";
  import { navigate } from "../router";
  import { Button, Label, Logo } from "./widget";
  import { HStack, VStack, Spacer, MediaQuery } from "./layout";

  function doLogout() {
    logout().then(() => navigate("/"));
  }

  let userRequest = getUser();
</script>

{#if $showLogin}
  <Login on:close={() => showLogin.set(false)} />
{/if}

<div class="line" />
<header>
  <MediaQuery query="(min-width: 481px)">
    <Logo />
  </MediaQuery>
  <div>
    <HStack grow alignment="stretch">
      <slot name="left" />
      <Spacer />
      <slot />
      <!-- <Button action={() => navigate('#/help')}>
        <Label text="Aide" icon="question" borderRight h="48px" />
      </Button> -->

      {#await $userRequest}
        <span>Connexion en cours...</span>
      {:then value}
        <Button action={doLogout}>
          <Label text={value.data.nickname} icon="user-times" h="48px" />
        </Button>
      {:catch error}
        <Button action={() => showLogin.set(true)}>
          <Label text="Connexion" icon="user" h="48px" />
        </Button>
      {/await}
    </HStack>
  </div>
</header>

<style>
  .line {
    width: 100%;
    padding: 0;
    height: 5px;
    z-index: 90;
    background-color: var(--primary-light-color);
  }
  header {
    width: inherit;
    padding: 0;
    height: 3rem;
    display: flex;
    align-items: stretch;
    flex-wrap: nowrap;
    z-index: 90;
    line-height: 3rem;
  }

  @media screen and (max-width: 480px) {
    header {
      position: absolute;
      width: 100%;
    }
  }

  header > div {
    flex-wrap: nowrap;
    flex: 1 1 0px;
    display: flex;
    justify-content: flex-end;
  }
</style>
